import { ReactNode } from "react";

interface IFloatingButtonProps {
    /** Nội dung icon — thường là <i className="fas fa-..." />. */
    icon: ReactNode;
    /** Nhãn text cạnh icon (tùy chọn) — FAB dạng extended. */
    label?: string;
    onClick: () => void;
    /** Badge số nhỏ góc phải trên (vd số bộ lọc đang áp dụng). */
    badge?: number;
    ariaLabel: string;
}

/**
 * Nút nổi (FAB) cố định góc dưới-phải, nằm trên BottomTabBar.
 * Touch target ≥ 44px (class `.m-fab` set min 52px).
 */
const FloatingButton = ({ icon, label, onClick, badge, ariaLabel }: IFloatingButtonProps) => {
    return (
        <button type="button" className="m-fab" onClick={onClick} aria-label={ariaLabel}>
            <span className="m-fab-icon">{icon}</span>
            {label && <span className="m-fab-label">{label}</span>}
            {badge != null && badge > 0 && <span className="m-fab-badge">{badge}</span>}
        </button>
    );
};

export default FloatingButton;
